export default __webpack_public_path__ + "static/media/janet-warne.bd0e539f.jpg";